import React, { useState, useRef, useEffect } from 'react'
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'
import neshanSearch from 'client-sdk/src/common/neshanSearch'
import handleError from '../../utils/handleError'

import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import './style.css'

interface SearchResult {
  geom: {
    coordinates: [number, number]
  }
  title: string
  address: string
  notFound?: boolean
}

const iconPerson = new L.Icon({
  iconUrl: '/pin.png',
  iconRetinaUrl: '/pin.png',
  iconSize: new L.Point(37, 37),
  className: 'map-position'
})

const MapboxMap = ({ setLatlng, positionMarker }: any) => {
  const [text, setText] = useState<string>('')
  const [results, setResults] = useState<SearchResult[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [position, setPosition] = useState<[number, number]>(
    positionMarker.lat === 0 ? [35.7219, 51.3347] : positionMarker
  )

  const inputRef = useRef<HTMLInputElement | null>(null)
  const markerRef = useRef(null)

  const lat = 35.7219
  const lng = 51.3347

  useEffect(() => {
    if (text.length > 1) {
      setIsLoading(true)
      const debounceTimeout = setTimeout(async () => {
        try {
          const res = await neshanSearch(text, lat, lng)
          if (res.ok) {
            setResults(res.res.items)
            setIsLoading(false)
          } else {
            setResults([])
          }
        } catch (error) {
          handleError(error)
          setResults([])
          setIsLoading(false)
        }
      }, 1000)
      return () => clearTimeout(debounceTimeout)
    }
  }, [text])

  const handleMapClick = (e: any) => {
    const { lat, lng } = e.latlng
    setPosition([lat, lng])
    setLatlng({ lat, lng })
  }
  const handlerclearTextInput = () => {
    inputRef.current?.focus()
    setText('')
    setResults([])
  }

  return (
    <div>
      <div style={{ marginBottom: '10px', textAlign: 'center' }}>
        <div className='container search-box'>
          <div className='container search-box__item flex-row'>
            <input
              ref={inputRef}
              autoComplete='off'
              type='text'
              id='search'
              placeholder='جستجو آدرس...'
              onChange={(e) => setText(e.target.value)}
              value={text}
            />
            {results.length > 0 && (
              <div onClick={handlerclearTextInput} className='clear-seach'>
                <span> &#10006; </span>
              </div>
            )}
          </div>
          {text.length > 1 && (
            <div className='search-box__item search-results'>
              {isLoading ? (
                <div className='search-result-item'>
                  <p className='search-result-item-title'>درحال جستجو ...</p>
                </div>
              ) : (
                results.map((item: any, index) => (
                  <div
                    className='search-result-item'
                    key={index}
                    onClick={() => {
                      setPosition([item.location.y, item.location.x])
                      setLatlng({
                        lat: item.location.y,
                        lng: item.location.x
                      })
                      setResults([])
                    }}
                  >
                    <p className='search-result-item-title'>{item.title}</p>
                    <p className='search-result-item-address'>{item.address}</p>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>

      <Map
        center={position}
        zoom={16}
        style={{ height: '700px', width: '100%' }}
        onClick={handleMapClick}
      >
        <TileLayer
          url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
          attribution='© OpenStreetMap contributors'
          maxZoom={40}
          minZoom={0}
        />
        <Marker icon={iconPerson} position={position} ref={markerRef}>
          <Popup>موقعیت فعلی شما</Popup>
        </Marker>
      </Map>
    </div>
  )
}

export default MapboxMap
